const footerLinks = [
  { label: "About", href: "#intro" },
  { label: "What We Do", href: "#what-we-do" },
  { label: "Platforms & Initiatives", href: "#platforms" },
  { label: "Legacy", href: "#legacy" },
  { label: "Partnerships", href: "#partners" },
  { label: "Contact", href: "#contact" },
];

const LOGO_URL =
  "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/9bbf6cf8-b106-4501-9333-f0d6926a8c4e_compressed_1631335680439.webp";

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="w-full bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="flex flex-col items-center text-center gap-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Amin & Jahan Corporation Ltd."
              className="h-10 w-auto object-contain"
            />
            <span className="font-heading font-bold text-base text-foreground-950">
              Amin &amp; Jahan Corporation Ltd.
            </span>
          </div>

          {/* Tagline */}
          <p className="text-sm font-medium tracking-wide text-foreground-600 uppercase">
            Research. Develop. Promote.
          </p>

          {/* Navigation */}
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-2">
            {footerLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Divider */}
          <div className="w-16 h-px bg-background-300 mt-4" />

          {/* Copyright */}
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Amin &amp; Jahan Corporation Ltd.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}